module.exports = __webpack_public_path__ + "img/stop.d6555ebb.svg";